/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 福祉データ 福祉区分
 */
export type BaseInfoWelfareDataWelfareDistrictEnum =
  (typeof BaseInfoWelfareDataWelfareDistrictEnum)[keyof typeof BaseInfoWelfareDataWelfareDistrictEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseInfoWelfareDataWelfareDistrictEnum = {
  AOBA: 'AOBA',
  MIYAGINO: 'MIYAGINO',
  WAKABAYASHI: 'WAKABAYASHI',
  TAIHAKU: 'TAIHAKU',
  IZUMI: 'IZUMI',
  MIYAGI_BRANCH: 'MIYAGI_BRANCH',
  AKIHO_BRANCH: 'AKIHO_BRANCH',
} as const;
